import { useSEO } from "../Utils/useSEO";
import { getManualViewerEmbedUrl } from "../constants/tutorialAssets";

export default function UserManualViewer() {
  useSEO({
    title: "User Manual // Supply Spot",
    description: "View the Supply Spot workflow and vendor onboarding user manual.",
  });

  return (
    <div
      className="fixed inset-0 bg-slate-100"
      onContextMenu={(event) => event.preventDefault()}
    >
      <iframe
        title="Supply Spot User Manual"
        src={getManualViewerEmbedUrl()}
        className="w-full h-full border-0"
        allowFullScreen
      />
    </div>
  );
}
